<div class="card" [class.selected]="selected" [class.without-flows]="flowsStatus != 'flows'"
     style="height: 100%; margin: 0px; background-color: rgb(242, 247, 251);">
  <div class="card-header" style="padding: 5px; background-color: rgb(232, 240, 250); color: #333">
    <div class="header-row">
      <button type="button" class="toggle" (mousedown)="$event.stopPropagation()" (click)="toggleFolded($event)"
              [title]="folded ? 'Unfold ' + appGroup.name + ': show its sub-groups and members' : 'Fold ' + appGroup.name + ' into one box'"
              [attr.aria-expanded]="!folded">
        {{ folded ? '▸' : '▾' }}
      </button>
      <span class="name">{{ appGroup.name }}</span>
      <cds-icon shape="cog" (click)="showAppGroupSettings(appGroup)" class="settings"></cds-icon>
    </div>
    @if (folded) {
      <div class="count">{{ foldedSummary }}</div>
    }
    @switch (flowsStatus) {
      @case ('silent') {
        <div class="flows-status" title="No flow between this group and the other groups of the file over the selected period. Flows with resources in no group are not drawn on this map.">
          No flows with other groups
        </div>
      }
      @case ('empty') {
        <div class="flows-status warning" title="This group has no member yet: edit it to add some.">
          <cds-icon shape="exclamation-triangle"></cds-icon> No members
        </div>
      }
      @case ('missing') {
        <div class="flows-status warning" title="None of the members of this group is known to the inventory over the selected period: they may have been removed or renamed.">
          <cds-icon shape="exclamation-triangle"></cds-icon> Members not found
        </div>
      }
    }
  </div>
  <div class="card-footer" style="max-height: 30px;">
  </div>
</div>

  @if (options != false) {

    <div class="card" style="margin: 0px;">
      <div class="card-block" style="padding: 0px;">
        <div class="card-text">
          <select name="membersDisplayMode" [(ngModel)]="appGroup.membersDisplayMode" style="width: 100%;" (change)="onMembersDisplayModeChange($event)">
            <option value="summarized">summarized</option>
            <option value="sub_groups">show sub-groups</option>
            <option value="servers">show exposing ports</option>
            <option value="servers_and_clients">show active</option>
            <option value="all">show all members</option>
            <option value="all_traffic">show all traffic (inside + outside)</option>
          </select>
        </div>
      </div>
    </div>

  }

